import React, { useState, useEffect } from 'react'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'

function Navigate({ isMobile, title, children, itemRef, totalItems, titleCSS, moveByPx }) {
  const [moveBy, setMoveBy] = useState(moveByPx || 100)
  const [leftArrowDisabled, setLeftArrowDisabled] = useState(false)
  const [rightArrowDisabled, setRightArrowDisabled] = useState(false)
  const [showArrows, setShowArrows] = useState(true)

  useEffect(() => {
    if (itemRef?.current) {
      function watchScroll() {
        itemRef.current.addEventListener('scroll', handleScroll)
      }
      watchScroll()
    }
    return () => {
      if (itemRef?.current) {
        itemRef.current.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  useEffect(() => {
    if (itemRef?.current && totalItems?.length > 0) {
      const { scrollWidth, scrollLeft, clientWidth } = itemRef.current
      if (scrollWidth > clientWidth) {
        //less interests. not enough to scroll
        setShowArrows(true)
      } else {
        setShowArrows(false)
      }
    }
  }, [totalItems])

  const scrollLeft = () => {
    if (itemRef?.current) {
      itemRef.current.scrollBy({ left: -moveBy, behavior: 'smooth' })
    }
  }

  const scrollRight = () => {
    if (itemRef?.current) {
      itemRef.current.scrollBy({ top: 0, left: moveBy, behavior: 'smooth' })
    }
  }
  function handleScroll() {
    if (itemRef?.current) {
      const { scrollWidth, scrollLeft, clientWidth } = itemRef.current
      if (scrollLeft === 0) {
        setLeftArrowDisabled(true)
        setRightArrowDisabled(false)
      } else if (Math.round(scrollWidth - scrollLeft) === clientWidth) {
        setRightArrowDisabled(true)
        setLeftArrowDisabled(false)
      } else {
        setLeftArrowDisabled(false)
        setRightArrowDisabled(false)
      }
    }
  }

  const handleKeyPressed = (e) => {
    if (e.key === 'ArrowRight') {
      scrollRight()
    } else if (e.key === 'ArrowLeft') {
      scrollLeft()
    }
  }
  return (
    <div
      className={styles.navigateContainer}
      onKeyUp={(e) => {
        handleKeyPressed(e)
      }}>
      <h1 className={titleCSS}>{title}</h1>
      <div className={styles.arrowWrapper}>
        {!isMobile && showArrows && (
          <button onClick={scrollLeft} disabled={leftArrowDisabled === true || itemRef?.current?.scrollLeft === 0}>
            <Icon name='chevron-left24' size='large24' styleModifier={styles.chevronIcon} />
          </button>
        )}
        {children}
        {!isMobile && showArrows && (
          <button
            onClick={scrollRight}
            disabled={
              rightArrowDisabled === true ||
              Math.round(itemRef?.current?.scrollWidth - itemRef?.current?.scrollLeft) === itemRef?.current?.clientWidth
            }>
            <Icon name='chevron-right24' size='large24' styleModifier={styles.chevronIcon} />
          </button>
        )}
      </div>
    </div>
  )
}

export default Navigate
